import { Icon } from "@atoms/icon";
import { Typography } from "@atoms/typography";
import React, { FC } from "react";
import { Trans, useTranslation } from "next-i18next";
import styled from "styled-components";

export const ContactThanks: FC = () => {
  const { t } = useTranslation("contact");

  return (
    <Container>
      <div className="icon-container">
        <Icon name="check" />
      </div>
      <Typography variant="title2">{t("thank-you")}</Typography>
      <Typography variant="body1">{t("for-contact-us")}</Typography>
      <Typography variant="body1">{t("we-will-be-in-touch-soon")}</Typography>
    </Container>
  );
};

const Container = styled.div`
  text-align: center;
  .icon-container {
    .fh-icon {
      color: #39857e;
      font-size: 8em;
    }
  }
`;
